export default {
  csatText: 'Consolidated CSAT',
};
